import { Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { Store } from 'antd/lib/form/interface';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import React from 'react';

interface IFormWrapper {
    layoutPosition?: 'vertical' | 'horizontal' | 'inline' | 'horizontalLongLabels';
    onFinish: (values: Store) => void;
    onFinishFailed?: (errorInfo: ValidateErrorEntity) => void;
    outForm?: FormInstance;
    name?: string;
    preserve?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onValuesChange?: (changedValues: any, allValues: any) => void;
    scrollToFirstError?: boolean;
    colon?: boolean;
    size?: 'small' | 'middle' | 'large';
    labelAlign?: 'left' | 'right';
    requiredMark?: boolean;
    children?: React.ReactNode;
    modalForm?: boolean;
    displayOnly?: boolean; // schova label extra vyuzivane validaciami co umozni mensie medzery medzi inputmi
}

const trimStringProperties = (obj: Record<string, any>): Record<string, any> => {
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // Check if the value is a string
            if (typeof obj[key] === 'string') {
                obj[key] = obj[key].trim(); // Trim the string value
            }
            // If the value is an object, recursively call the function
            else if (typeof obj[key] === 'object' && obj[key] !== null) {
                trimStringProperties(obj[key]);
            }
        }
    }
    return obj;
};

// Function to delete properties with an empty string value
const deleteEmptyStrings = (obj: Record<string, any>): Record<string, any> => {
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // If the value is an empty string, delete the property
            if (obj[key] === '') {
                delete obj[key];
            }
            // If the value is an object, recursively call the function
            else if (typeof obj[key] === 'object' && obj[key] !== null) {
                deleteEmptyStrings(obj[key]);
            }
        }
    }
    return obj;
};

const FormWrapper: React.FC<IFormWrapper> = props => {
    const [form] = Form.useForm();
    const {
        onFinish,
        children,
        layoutPosition = 'vertical',
        onFinishFailed,
        outForm,
        name = 'login',
        preserve,
        requiredMark,
        displayOnly,
        modalForm,
        ...rest
    } = props;
    const layout =
        layoutPosition === 'horizontal'
            ? {
                  labelCol: {
                      span: modalForm ? 10 : 6
                  },
                  wrapperCol: {
                      span: modalForm ? 14 : 18
                  }
              }
            : layoutPosition === 'horizontalLongLabels'
              ? {
                    labelCol: {
                        span: 14
                    },
                    wrapperCol: {
                        span: 8
                    }
                }
              : {
                    labelCol: {
                        span: 24
                    }
                };
    return (
        <Row
            justify="start"
            style={{
                width: '100%'
            }}
        >
            <Form
                labelAlign={layoutPosition === 'horizontal' ? 'left' : 'right'}
                {...layout}
                colon={false}
                layout={layoutPosition === 'horizontalLongLabels' ? 'horizontal' : layoutPosition}
                form={outForm ? outForm : form}
                scrollToFirstError={true}
                name={name}
                preserve={preserve}
                initialValues={{
                    remember: true
                }}
                onFinish={values => {
                    const trimmedVals = trimStringProperties(values);
                    const cleanObj = deleteEmptyStrings(trimmedVals);
                    onFinish(cleanObj);
                }}
                onFinishFailed={onFinishFailed}
                style={{
                    width: '100%'
                }}
                requiredMark={requiredMark}
                className={displayOnly ? 'formDisplayOnly' : undefined}
                disabled={displayOnly}
                {...rest}
            >
                {children}
            </Form>
        </Row>
    );
};

export default FormWrapper;
